module.exports = __webpack_public_path__ + "static/media/forward-arrow.3c2c0472.png";